module.exports = require('./helpers/bundle-url').getBundleURL('7ucCx') + "logo-dark.eefe0b7f.svg";